import { SignWaiverFlow } from '_organisms';
import React from 'react';

const Waivers: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-lg md:text-3xl font-bold text-gray-900 mb-2">
          Waivers
        </h1>
        <p className="text-gray-600">
          You'll need a valid waiver to skate. Please read and sign the
          following waivers before attending the event.
        </p>
      </div>
      <SignWaiverFlow />
    </div>
  );
};

export default Waivers;
